/**
 * Figures each page shows: column headers, stat tile labels and chart series.
 *
 * Generated from the route sources. Do not edit.
 * Run `npm run figures:index` in frontend/.
 */

export const FIGURES_BY_PAGE: Readonly<Record<string, readonly string[]>> = {
  'account-change-log': [
    'Account #',
    'Action',
    'Category',
    'Change',
    'Changed as',
    'Changed by',
    'Customer',
    'Customer #',
    'From',
    'Merchant',
    'Record',
    'Source',
    'To',
    'When'
  ],
  'account-delinquency': [
    '1-30 days',
    '31-60 days',
    '61-90 days',
    '91+ days',
    '91+ days past due',
    'Accounts',
    'Delinquent',
    'Delinquent share',
    'Merchant',
    'Merchant ID',
    'Paid',
    'Snapshot'
  ],
  'ach-daily': [
    'ACH attempts',
    'Amount',
    'Amount (USD)',
    'Attempts',
    'Day',
    'Declined',
    'Merchant',
    'Processed',
    'Reason',
    'Reason code',
    'Return rate',
    'Returned',
    'Status'
  ],
  'ach-merchant-rejections': [
    'Debits originated',
    'Merchant',
    'Merchant ID',
    'Originated amount',
    'Originated amount (USD)',
    'Reject rate',
    'Reject rate (%)',
    'Reject rate by count',
    'Reject rate by dollars',
    'Reject rate by dollars (%)',
    'Rejected',
    'Rejected amount',
    'Rejected amount (USD)',
    'Stopped before submission',
    'Successful',
    'Successful amount',
    'Successful amount (USD)'
  ],
  'ach-nacha-rates': [
    'Administrative return rate',
    'Administrative return rate (%)',
    'Administrative returns',
    'Administrative status',
    'Debits attempted',
    'Debits originated',
    'Insufficient funds returns',
    'Merchant',
    'Merchant ID',
    'NACHA limit',
    'Overall return rate',
    'Overall return rate (%)',
    'Overall status',
    'Returns',
    'Unauthorized return rate',
    'Unauthorized return rate (%)',
    'Unauthorized returns',
    'Unauthorized status'
  ],
  'ach-reason-codes': [
    'Amount',
    'Amount (USD)',
    'Code',
    'Counted by',
    'Declines',
    'Events',
    'Kind',
    'Merchant',
    'Month',
    'Reason',
    'Returns',
    'Returns by attempt month',
    'Returns received'
  ],
  'ach-return-reasons': [
    'Administrative returns',
    'Code',
    'Description',
    'Merchant',
    'Merchant ID',
    'NACHA bucket',
    'Returned amount',
    'Returned amount (USD)',
    'Returns',
    'Unauthorized returns'
  ],
  'ach-returns': [
    'ACH charges',
    'Amount returned',
    'Amount returned (USD)',
    'Counts as unauthorized',
    'Return code',
    'Return rate',
    'Return rate (%)',
    'Returns',
    'Share of returns',
    'Share of returns (0-1)',
    'Unauthorized return rate',
    'What it means'
  ],
  'ach-trends': [
    'ACH attempts',
    'Attempts',
    'Declined',
    'Merchant',
    'Month',
    'Processed',
    'Processed amount',
    'Processed amount (USD)',
    'Return rate',
    'Return rate (%)',
    'Returned',
    'Returned amount',
    'Returned amount (USD)',
    'Returns received'
  ],
  'ach-volume-trends': [
    'Debits processed',
    'Merchant',
    'Merchant ID',
    'Notices of change',
    'Period',
    'Processed amount',
    'Processed amount (USD)',
    'Processed dollars',
    'Return rate by dollars',
    'Returned amount',
    'Returned amount (USD)',
    'Returned dollars',
    'Returns',
    'Stopped before submission'
  ],
  'ai-decline-codes': [
    'Code',
    'Code sequence',
    'Distinct codes',
    'Failures',
    'Mature failures',
    'Median minutes to pay',
    'New card',
    'Other saved card',
    'Paid in 7 days',
    'Reason',
    'Same card',
    'Same code again',
    'Share of failures',
    'Split pay'
  ],
  'ai-decline-impact': [
    'AI texts from',
    'Change',
    'Change (points)',
    'Code',
    'Comparison change',
    'Comparison change (points)',
    'Comparison median',
    'Decline code',
    'Decline reason',
    'Declined dollars recovered',
    'Declined invoices paid within 7 days of due',
    'Declines after',
    'Declines before',
    'Declines recovered within 24 hours',
    'Median after',
    'Median before',
    'Median minutes after',
    'Median minutes before',
    'Median time from decline to payment',
    'Median time to payment',
    'Merchant',
    'Origin pair',
    'Payment origin',
    'Reason',
    'Recovered after',
    'Recovered after ($)',
    'Recovered before',
    'Recovered share after',
    'Recovered share before'
  ],
  'ai-decline-journeys': [
    'AI customers',
    'Account',
    'Attempt 1',
    'Attempt 1 code',
    'Attempt 1 origin',
    'Attempt 1 reason',
    'Average attempt that paid (AI / comparison)',
    'Average decline to payment (AI / comparison)',
    'Average first decline to payment',
    'Comparison customers',
    'Customer',
    'Customers with an AI-code decline',
    'Decline code',
    'First decline',
    'First decline (UTC)',
    'First decline to payment',
    'Have paid since',
    'Merchant',
    'Paid on attempt',
    'Paid origin',
    'Paid since (AI / comparison)',
    'Seconds from first decline to payment'
  ],
  'ai-texts': [
    'Account',
    'Action time',
    'Balance given',
    'Customer',
    'Link provided',
    'Location',
    'Merchant',
    'Messages sent',
    'Promise',
    'Promise cancelled',
    'Status'
  ],
  'bin-mcc-fee-report': [
    'Amaryllis fees',
    'Amaryllis fees (USD)',
    'Amex',
    'Amount',
    'Amount (USD)',
    'BIN',
    'BINs',
    'Convenience fees',
    'Convenience fees (USD)',
    'Cost as % of amount',
    'Cost as % of volume',
    'Date',
    'Date (UTC)',
    'Discover',
    'Interchange fees',
    'Interchange fees (USD)',
    'MCC',
    'Mastercard',
    'Merchant',
    'Merchant network fees',
    'Merchant network fees (USD)',
    'Org ID',
    'SaaS transaction fees',
    'SaaS transaction fees (USD)',
    'Transaction',
    'Transactions',
    'Visa',
    'Volume processed',
    'Volume processed (USD)'
  ],
  'blytzcollect-analytics': [
    '# of payments',
    '# of promises',
    'Average amount',
    'Avg Calls to Pay',
    'Call Time',
    'Call → Payment',
    'Connected',
    'Connected – Meaningful Outcome',
    'Connected – Unauthenticated/Hang Up',
    'Cycles Collected',
    'Invoice → Payment',
    'Paid Without Promising',
    'Paid by call link',
    'Promised Money Collected',
    'Promises Kept',
    'Successful Transfers',
    'Total Calls',
    'Total amount'
  ],
  'by-origin': [
    'Auto-reversed',
    'Chargebacks',
    'Disputed amount',
    'Disputed amount (USD)',
    'Disputes',
    'Lost',
    'Not represented',
    'Not saved method',
    'On a recurring method',
    'On a saved method',
    'Payment origin',
    'Pending',
    'Recurring',
    'Recurring amount',
    'Recurring amount (USD)',
    'Recurring share of saved',
    'Recurring share of saved (%)',
    'Saved method',
    'Saved share',
    'Saved share (%)',
    'Saved-method amount',
    'Saved-method amount (USD)',
    'Won'
  ],
  'chargeback-disputes': [
    'Age (Eastern civil days)',
    'Age (Eastern days)',
    'Age bucket',
    'Disputed amount',
    'Disputed amount (USD)',
    'First chargeback',
    'First chargeback (Eastern)',
    'Inferred outcome',
    'Latest chargeback',
    'Latest chargeback (Eastern)',
    'Merchant',
    'Merchant ID',
    'Processor transaction ID',
    'Reason code',
    'Reason description',
    'Represented',
    'Unrepresented'
  ],
  'collections-scorecard': [
    '30+ days late or unpaid',
    '30+ late or unpaid',
    '30+ late or unpaid %',
    'Accounts',
    'Autopay',
    'Autopay %',
    'Avg days late',
    'Called',
    'Called %',
    'Check data',
    'Cured by day 30',
    'Cured by day 30 %',
    'Invoices',
    'Late at day 7',
    'Late at day 7, paid by day 30',
    'Merchant',
    'Never paid',
    'Never paid %',
    'Org id',
    'Paid on or before due',
    'Paid on time',
    'Paid on time %',
    'Self-serve',
    'Self-serve %',
    'Texts days 1-7 per late invoice',
    'Texts days 1–7',
    'Texts per invoice'
  ],
  'cs-payment-origin': [
    'Autopay',
    'BlytzCollect',
    'Change (percentage points)',
    'Change transactions pts',
    'Customer self-service',
    'Label',
    'Merchant-entered',
    'Origin',
    'Prior share of transactions',
    'Prior transaction share',
    'Same month last year',
    'Share of transactions',
    'This month',
    'Transaction share',
    'Transactions'
  ],
  'cs-scorecard': [
    'Active merchants',
    'Merchant growth YoY',
    'Merchants yoy',
    'Month',
    'Partial',
    'Same month last year',
    'This month',
    'Transaction growth YoY',
    'Transactions',
    'Transactions yoy'
  ],
  'cs-tools-autopay-accounts': [
    'Account',
    'Amount',
    'Amount (USD)',
    'Autopay date',
    'Custom',
    'Enabled',
    'Last four',
    'Payment type',
    'Schedule',
    'Status'
  ],
  'cs-tools-registrations': [
    'Account',
    'Account created',
    'Account created (UTC)',
    'Account status',
    'Customer',
    'Email',
    'Merchant',
    'Registrations',
    'Terms accepted',
    'User active'
  ],
  'customer-list': [
    'Account ID',
    'Customer ID',
    'Customers on active accounts',
    'Email',
    'First name',
    'Last name',
    'Location',
    'Merchant',
    'Mobile phone'
  ],
  'decline-by-mid': [
    'ACH returns',
    'Approved',
    'Approved amount',
    'Approved amount (USD)',
    'Approved charges',
    'Attempts',
    'Decline rate',
    'Decline rate (%)',
    'Decline rate with verifies',
    'Decline rate with verifies (%)',
    'Declined',
    'Declined amount',
    'Declined amount (USD)',
    'Declined charges',
    'MCC',
    'MID',
    'MIDs',
    'Merchant',
    'Merchant ID',
    'Methods',
    'Period starts',
    'Refund amount',
    'Refund amount (USD)',
    'Refund rate',
    'Refund rate (%)',
    'Refunds',
    'Success rate',
    'Success rate (%)',
    'Verifies approved',
    'Verifies declined'
  ],
  'decline-payment-journey': [
    'Account',
    'Attempt 1',
    'Attempt 1 code',
    'Attempt 1 origin',
    'Attempt 1 reason',
    'Average attempt that paid',
    'Average decline to payment',
    'Average first decline to payment',
    'Customer',
    'Customers',
    'Customers with a decline',
    'Decline code',
    'First decline',
    'First decline (UTC)',
    'First decline to payment',
    'Have paid since',
    'Merchant',
    'Paid on attempt',
    'Paid on the next attempt',
    'Paid origin',
    'Paid since',
    'Seconds from first decline to payment'
  ],
  'decline-retries': [
    'Average hours to retry',
    'Card declines',
    'Class',
    'Decline code',
    'Declined again',
    'Declined amount',
    'Declined amount (USD)',
    'Declines',
    'Do not retry',
    'Do-not-retry declines retried',
    'Hard declines retried',
    'Merchant',
    'Merchant ID',
    'Not retried',
    'Period starts',
    'Recovered amount',
    'Recovered amount (USD)',
    'Retried',
    'Retried 1 to 24 h',
    'Retried 24 to 84 h',
    'Retried and approved',
    'Retried declines',
    'Retried under 1 h',
    'Retried, declined again',
    'Retry approved',
    'Retry rate',
    'Retry rate (%)',
    'Retry success rate',
    'Retry success rate (%)',
    'What it means'
  ],
  declines: [
    'ACH decline rate',
    'ACH return rate',
    'Administrative returns',
    'Amount',
    'Amount (USD)',
    'Attempts',
    'Bucket',
    'Card decline rate',
    'Card declines',
    'Code',
    'Do-not-retry card declines',
    'Events',
    'Kind',
    'Merchant',
    'Merchant ID',
    'Period starts',
    'Rate',
    'Rate (%)',
    'Share of limit used (%)',
    'Unauthorized returns',
    'What it means'
  ],
  'dms-volume': [
    'AMS',
    'Active merchants',
    'Average ticket',
    'Average ticket (USD)',
    'DMS',
    'Emotive',
    'IDMS',
    'Loan Pro',
    'None',
    'Period',
    'Rent Manager',
    'Standalone',
    'TCV',
    'TPV',
    'TPV (USD)'
  ],
  'duplicate-ach': [
    'Amount',
    'Amount (USD)',
    'At other merchants',
    'Attempts',
    'Flagged',
    'Merchant',
    'Used at more than one merchant'
  ],
  'duplicate-cards': [
    'Amount',
    'Amount (USD)',
    'At other merchants',
    'Attempts',
    'Flagged',
    'Merchant',
    'Used at more than one merchant'
  ],
  'duplicate-payments': [
    'Charges',
    'Charges in duplicates',
    'Day',
    'Duplicates',
    'Merchant',
    'Payment origin',
    'Repeated amount',
    'Repeated amount (USD)',
    'Repeated charges'
  ],
  'feature-adoption': [
    'Ach enabled',
    'Active',
    'Auto intell',
    'Automated Intelligence',
    'Autopay count',
    'Autopay retry',
    'Autopay run time',
    'BlytzCash',
    'BlytzCollect',
    'BlytzCollect IVR',
    'Cash count',
    'Cash method enabled',
    'Cash method on',
    'Enabled',
    'Has contract',
    'Hide multicard',
    'Ivr count',
    'Merchant',
    'Merchant ID',
    'Merchants',
    'Merchants shown',
    'Org biller',
    'Organization biller',
    'Paid count',
    'Paid payments',
    'Processor',
    'Requested count',
    'Requested payments',
    'Retry count',
    'Show balance',
    'Timezone',
    'Used',
    'Voice count'
  ],
  'follow-up-report': [
    'Account ID',
    'Assigned To',
    'Cancelled',
    'Completed',
    'Completed Date',
    'Created',
    'Created By',
    'Created Date',
    'First Name',
    'Last Name',
    'Merchant',
    'Overdue',
    'Scheduled',
    'Scheduled Date',
    'Status',
    'Total follow-ups'
  ],
  'go-live-ramp-up': [
    'Actual volume',
    'Actual volume (USD)',
    'Close date',
    'Cumulative volume',
    'Cumulative volume (USD)',
    'Days live',
    'Go-live date',
    'Green',
    'Has a target',
    'Has transactions',
    'MVV granted',
    'Merchant',
    'Merchant ID',
    'Merchants',
    'Merchants in the cohort',
    'Month in ramp',
    'Near target',
    'Orange',
    'Owner',
    'Pending',
    'Projected monthly volume',
    'Projected monthly volume (USD)',
    'Red',
    'Status',
    'Target met',
    'Target met (%)',
    'Target volume',
    'Target volume (USD)',
    'Week of',
    'Week volume',
    'Week volume (USD)',
    'Weeks since go-live',
    'Yellow'
  ],
  'high-low-tickets': [
    '8-week average',
    '8-week average (USD)',
    'Amount',
    'Amount (USD)',
    'Average ticket',
    'Average ticket (USD)',
    'Merchant',
    'Merchants',
    'Tickets',
    'x 8-week average'
  ],
  'hubspot-sync': [
    'Active in BlytzPay',
    'BlytzPay DMS',
    'DMS mismatch',
    'DMS mismatches',
    'First transaction',
    'Go-live mismatch',
    'Go-live mismatches',
    'HubSpot DMS',
    'HubSpot company',
    'HubSpot company id',
    'HubSpot go-live',
    'HubSpot owner',
    'HubSpot status',
    'Merchant',
    'Merchant id',
    'Merchants that disagree',
    'Mismatches',
    'Missing link',
    'Missing links',
    'Status mismatch',
    'Status mismatches'
  ],
  'inbound-messages': [
    'Account',
    'Adjusted response',
    'Adjusted response (business min)',
    'Agent',
    'Agents texting',
    'All messages',
    'Answered within 7 days',
    'Average adjusted response',
    'Average first response',
    'Avg adjusted response',
    'Avg adjusted response (business min)',
    'Avg first response',
    'Avg first response (min)',
    'Category',
    'Conversations',
    'Conversations answered',
    'Customer',
    'Customer #',
    'Customers worked',
    'Day',
    'Email',
    'First response',
    'First response (min)',
    'Inbound',
    'Inbound texts',
    'Median adjusted response',
    'Median adjusted response (business min)',
    'Median first response',
    'Median first response (min)',
    'Merchant',
    'Message',
    'Received',
    'Responded',
    'Texts sent'
  ],
  'location-lookup': [
    'City',
    'Location name',
    'Location pkid',
    'Matching locations',
    'Matching organizations',
    'Organization name',
    'Organization pkid',
    'Organization status',
    'Organizations with no location',
    'State'
  ],
  locations: [
    'Active locations',
    'Address',
    'City',
    'DMS',
    'DMS source',
    'Dealership ID',
    'Last payment',
    'Location',
    'Location ID',
    'Locations',
    'Merchant',
    'Merchant status',
    'Merchants',
    'Paid payments',
    'Paid volume',
    'Paying customers',
    'Phone',
    'State',
    'States'
  ],
  'master-list': [
    'Account created',
    'Account pkid',
    'City',
    'DBA name',
    'DMS',
    'DMS source',
    'Dealership ID',
    'First transaction',
    'Go-live',
    'Go-live source',
    'HubSpot status',
    'Location',
    'MCC',
    'MID',
    'Merchant',
    'Merchants',
    'Merchants never transacted',
    'Merchants with a DMS',
    'Merchants with a go-live',
    'Nickname',
    'PF application',
    'PF debit account',
    'PF sub-account',
    'PayFacto',
    'Payment template',
    'Primary',
    'ProPay',
    'Processing accounts (MIDs)',
    'Processor setting',
    'State',
    'Status',
    'ZIP'
  ],
  'merchant-360': [
    '30+ late or unpaid',
    'Active callouts',
    'Autopay enabled',
    'Callout',
    'Category',
    'Detail',
    'Field',
    'Messages',
    'Open reconciliation',
    'Payments',
    'Registrations',
    'Severity',
    'Signal',
    'Value'
  ],
  'merchant-outliers': [
    'Baseline deviation',
    'Baseline deviation (USD)',
    'Baseline mean',
    'Baseline mean (USD)',
    'Baseline weeks',
    'Decreases',
    'Distance from baseline',
    'Flagged',
    'Merchant',
    'Merchant ID',
    'Merchants',
    'Risk Dashboard flag',
    'Risk Dashboard flags',
    'Significant decreases',
    'Significant increases',
    'Status',
    'Stopped',
    'Stopped processing',
    'Symmetric status',
    'TPV',
    'Week TPV',
    'Week TPV (USD)',
    'Week-over-week change',
    'Week-over-week change (%)',
    'z-score'
  ],
  'merchant-profile': [
    'Active accounts',
    'BlytzCollect',
    'BlytzCollect live',
    'BlytzCollect status set',
    'DMS',
    'DMS source',
    'First BlytzCollect call',
    'Go-live',
    'Go-live source',
    'Last week TPV',
    'Last week TPV (USD)',
    'Last week starting',
    'Last week transactions',
    'Merchant',
    'Merchant ID',
    'Merchants',
    'Outlier last week',
    'Outlier weeks',
    'Status',
    'Std dev of TPV changes',
    'Std dev of TPV changes (%)',
    'TPV',
    'TPV in the period',
    'TPV in the period (USD)',
    'TPV in the window',
    'TPV week over week',
    'TPV week over week (%)',
    'TPV, outlier week',
    'Total accounts',
    'Transactions',
    'Transactions in the period',
    'Transactions in the window',
    'Transactions week over week',
    'Transactions week over week (%)',
    'Transactions, outlier week'
  ],
  'merchant-risk': [
    'ACH unauthorized rate',
    'ACH unauthorized rate (%)',
    'Approval rate',
    'Approval rate (%)',
    'Chargeback amount',
    'Chargeback amount (USD)',
    'Chargeback breaches',
    'Chargeback rate',
    'Chargeback rate (%)',
    'Chargebacks',
    'Critical tier',
    'Decline rate',
    'Decline rate (%)',
    'Dispute win rate',
    'Dispute win rate (%)',
    'Flags',
    'High tier',
    'MCC',
    'Merchant',
    'Merchant ID',
    'Merchants',
    'Refund rate',
    'Refund rate (%)',
    'Risk score',
    'Tenure (months)',
    'Tier',
    'Tier reason',
    'Transactions',
    'Volume',
    'Volume (USD)',
    'Volume processed',
    'Volume spike',
    'Volume spike (x)',
    'Week-over-week outlier',
    'Week-over-week volume',
    'Week-over-week volume (%)'
  ],
  'merchant-settings': [
    'AI texts',
    'Active',
    'Address',
    'Address 2',
    'Allow group message',
    'Allow waiving fees',
    'Apply billing threshold',
    'Autopay continuation',
    'Autopay execution time',
    'Autopay retry',
    'Billing automation active',
    'Billing cycle',
    'Billing method',
    'BlytzCollect set up',
    'BlytzPay convenience fee',
    'Check custom roles',
    'City',
    'Consumer may pay a different amount',
    'Convenience fee billing threshold',
    'Convenience fee on autopay',
    'Convenience fee on misc payments',
    'Convenience fee on promises',
    'Convenience fee on scheduled payments',
    'Cost-plus pricing',
    'Country',
    'Currency',
    'Custom payments',
    'Custom settings',
    'Customer-level payment rules',
    'DMS integration',
    'Days past due',
    'Decline messages (old merchant flag)',
    'Decline texts',
    'Description',
    'External ID',
    'Hide multicard',
    'IDMS user',
    'InComm UPC ID',
    'InComm biller ID',
    'Inbox filtering',
    'Integration URL',
    'Integration type',
    'Ituran',
    'Logged payments',
    'Logo',
    'Max payment %',
    'Max payment amount',
    'Merchant',
    'Merchant-only autopay',
    'Min payment %',
    'Min payment amount',
    'Org ID',
    'Partner ID',
    'PassTime',
    'Payment routing',
    'Platform type',
    'Postal code',
    'Processor',
    'Promise continuation',
    'Propay affiliate',
    'Reply email',
    'Requested payments',
    'Require CVV',
    'Show balance to customer',
    'State / province',
    'Support email',
    'Time zone',
    'Website',
    'Whitelabel'
  ],
  'merchant-users': [
    'Added or invited',
    'Can sign in',
    'Email',
    'First name',
    'Invite expires',
    'Last name',
    'Last sign-in',
    'Open invites',
    'Staff logins',
    'Status'
  ],
  'merchant-weekly-tiers': [
    'ACH TPV',
    'ACH TPV (USD)',
    'Active',
    'Average weekly TPV',
    'Average weekly TPV (USD)',
    'BlytzCash TPV',
    'BlytzCash TPV (USD)',
    'Card TPV',
    'Card TPV (USD)',
    'Kiosk TPV',
    'Kiosk TPV (USD)',
    'Last week TPV',
    'Last week TPV (USD)',
    'Merchant',
    'Merchant ID',
    'Merchants',
    'Merchants over $300K a week',
    'TPV',
    'Tier',
    'Total TPV',
    'Total TPV (USD)',
    'Transactions',
    'Week of',
    'Weeks counted'
  ],
  'message-report': [
    'Account',
    'Cell Phone',
    'Channels',
    'Delivered Email',
    'Delivered Text',
    'Email',
    'Emails sent',
    'Group',
    'Individual',
    'Merchant',
    'Messages sent',
    'Opted Out',
    'Received',
    'Recipient',
    'Reminder',
    'Sent',
    'Sent / Scheduled',
    'Sent / Scheduled (UTC)',
    'Sent by a user',
    'Single',
    'Source',
    'Status',
    'System',
    'Template',
    'Text',
    'Texts received',
    'Texts sent',
    'Time zone',
    'Type',
    'Undelivered',
    'Undelivered texts'
  ],
  mmpv: [
    '% of MMPV',
    'Agreement',
    'BlytzPay merchant',
    'Clause number',
    'Effective',
    'Effective date',
    'Latest month',
    'Latest month transactions',
    'Latest month volume',
    'Latest share of threshold',
    'MMPV',
    'Mapping note',
    'Meeting MMPV',
    'Merchant ids',
    'Month',
    'Month to date pace',
    'Month to date volume',
    'Monthly threshold',
    'Not checked',
    'Priority',
    'Status',
    'Template',
    'This month so far',
    'Transactions',
    'Under MMPV',
    'Volume'
  ],
  'multicard-usage': [
    'Consumer',
    'Consumer initiated',
    'Merchant',
    'Merchant initiated',
    'Merchants',
    'Total'
  ],
  'onboarding-pipeline': [
    'AMS',
    'Active customers',
    'Company',
    'Deal close date',
    'Emotive Software',
    'Exited underwriting',
    'Has a deal',
    'IDMS',
    'Industry',
    'Loan Pro',
    'Management system',
    'Management system value',
    'Month end',
    'None',
    'Open or closed',
    'Owner',
    'Proposed go-live',
    'Rent Manager',
    'Stage',
    'Stage order',
    'Standalone',
    'State',
    'Status',
    'Ticket',
    'Tickets',
    'Value before bucketing'
  ],
  'opt-out-sources': [
    'By a merchant',
    'By the customer',
    'Channel',
    'Merchant',
    'Merchant ID',
    'Not in logs',
    'Opt-outs',
    'Opted out by',
    'STOP texts',
    'Source'
  ],
  'opt-outs': [
    'Account #',
    'Customer #',
    'Media',
    'Merchant',
    'Name',
    'Opt out date',
    'Other'
  ],
  overview: [
    'Auto-reversed',
    'Card sales',
    'Chargeback rate',
    'Chargeback ratio',
    'Chargeback ratio (%)',
    'Chargebacks',
    'Disputed amount',
    'Disputed amount (USD)',
    'Lost',
    'Lost (USD)',
    'Merchant',
    'Merchant id',
    'Month',
    'Not represented',
    'Pending',
    'Pending or not decided',
    'Platform account',
    'Representments',
    'Won',
    'Won (USD)',
    'Won / lost'
  ],
  'owner-payments': [
    'Amount',
    'Amount (USD)',
    'Charges',
    'Merchant',
    'Merchants',
    'Own-account charges',
    'Owner-paid charges',
    'Payment method'
  ],
  'payer-experience': [
    'All other',
    'Apple Pay',
    'Attempted amount',
    'Attempts',
    'Credit',
    'Debit',
    'Decline rate',
    'Decline reason',
    'Declined attempts',
    'Merchant',
    'Merchant ID',
    'Month',
    'No wallet',
    'Outcome',
    'Payment method',
    'Prepaid',
    'Success rate',
    'Unknown card',
    'Wallet'
  ],
  'payment-origin-share': [
    'Failed payments',
    'Month',
    'Origin',
    'Origin code',
    'Paid payments',
    'Payments',
    'Share',
    'Share (0 to 1)',
    'Status'
  ],
  'payment-report': [
    'ACH',
    'Account',
    'All other origins',
    'Amount',
    'Apple Pay',
    'Card',
    'Cash',
    'Collector',
    'Conv fee',
    'Decline rate',
    'Declined',
    'Last four',
    'Logged',
    'Merchant',
    'Merchant account',
    'Name',
    'Origin',
    'Other',
    'Processed',
    'Processed (UTC)',
    'Processor transaction ID',
    'Receipt',
    'Status',
    'Successful',
    'Total',
    'Total Payments',
    'Type'
  ],
  'platform-activity': [
    'BlytzCash per hour',
    'Busiest occurrence (payments)',
    'Combined load',
    'Customers',
    'Declines per hour',
    'Hour',
    'Kiosk per hour',
    'Load index',
    'Merchant operators',
    'Merchant sign-ins',
    'Occurrences',
    'Operators seen in 7 days',
    'Payments',
    'Payments per hour',
    'Quietest window',
    'Rank',
    'Seen in 1 day',
    'Seen in 30 days',
    'Seen in 7 days',
    'Sign-ins per hour',
    'Users',
    'Volume per hour',
    'Volume per hour (USD)',
    'Weekday',
    'Window',
    'With a login'
  ],
  'platform-jobs': [
    'Description',
    'Finished',
    'Job id',
    'Last run status',
    'Owner',
    'Rows written',
    'Schedule'
  ],
  'portfolio-callouts': [
    'Active',
    'Active signals',
    'Categories',
    'Evidence',
    'Evidence and rules',
    'High priority',
    'Main signal',
    'Merchant',
    'Merchant id',
    'Merchants evaluated',
    'Severity',
    'Signals',
    'With callouts'
  ],
  'portfolio-risk-kpis': [
    'ACH',
    'ACH administrative return rate',
    'ACH administrative return rate (%)',
    'ACH administrative returns',
    'ACH administrative status',
    'ACH debits originated',
    'ACH overall return rate',
    'ACH overall return rate (%)',
    'ACH overall status',
    'ACH returns',
    'ACH returns complete',
    'ACH unauthorized return rate',
    'ACH unauthorized return rate (%)',
    'ACH unauthorized returns',
    'ACH unauthorized status',
    'ACH volume',
    'ACH volume (USD)',
    'Administrative return rate',
    'Approval rate',
    'Approval status',
    'Barcodes generated',
    'Barcodes paid',
    'BlytzCash',
    'BlytzCash barcodes paid rate',
    'BlytzCash barcodes paid rate (%)',
    'BlytzCash paid share',
    'BlytzCash paid share (%)',
    'BlytzCash payments',
    'BlytzCash voided',
    'BlytzCash volume',
    'BlytzCash volume (USD)',
    'Card',
    'Card approval rate',
    'Card approval rate (%)',
    'Card attempts',
    'Card decline rate',
    'Card decline rate (%)',
    'Card declines',
    'Card refund rate',
    'Card refund rate (%)',
    'Card refund volume',
    'Card refund volume (USD)',
    'Card transactions',
    'Card volume',
    'Card volume (USD)',
    'Chargeback rate',
    'Chargeback rate (%)',
    'Chargeback status',
    'Chargeback volume',
    'Chargeback volume (USD)',
    'Chargebacks',
    'Decline rate',
    'Decline status',
    'Kiosk',
    'Kiosk payments',
    'Kiosk volume',
    'Kiosk volume (USD)',
    'Month',
    'Overall return rate',
    'Sales volume',
    'Sales volume (USD)',
    'Transactions',
    'Unauthorized return rate'
  ],
  processors: [
    'Check',
    'Dealership ID',
    'Dual-enabled',
    'Has a mismatch',
    'MIDs',
    'Merchant',
    'Merchants',
    'Mismatches',
    'On PayFacto',
    'On ProPay',
    'PF sub-accounts',
    'PayFacto accounts',
    'ProPay accounts',
    'Processing accounts',
    'Processor',
    'Status',
    'With dual-enabled accounts'
  ],
  'product-request-triage': [
    'Days in stage',
    'Gate',
    'Problem',
    'Request',
    'Revenue at stake ($/yr)',
    'Risk or cost avoided ($/yr)',
    'Score',
    'Stage',
    'Status',
    'Submitted at',
    'Submitted by',
    'Team',
    'Value at stake',
    'Value at stake ($/yr)'
  ],
  'product-requests': [
    'Mine, open',
    'Open requests',
    'Released',
    'Waiting for triage'
  ],
  'propensity-accuracy': [
    'Account ID',
    'Amount paid',
    'Chance to pay',
    'Chance to pay %',
    'Chance to pay this week',
    'Chance to pay this week %',
    'Chance to pay today',
    'Chance to pay today %',
    'Chance to promise',
    'Chance to promise %',
    'Confidence',
    'External ID',
    'Judged',
    'Likely promise',
    'Likely promise, typical miss',
    'Merchant',
    'Merchant ID',
    'Paid',
    'Paid on the day scored',
    'Paid this week',
    'Paid today',
    'Paid within 30 days',
    'Paid within 7 days',
    'Pay: actual',
    'Pay: judged',
    'Pay: predicted',
    'Predicted to pay',
    'Promise: actual',
    'Promise: judged',
    'Promise: predicted',
    'Promised',
    'Promised amount',
    'Promised within 30 days',
    'Score band',
    'Scored on',
    'Scores tracked'
  ],
  'propensity-to-pay': [
    'Chance a promise is kept',
    'Chance to make a promise in 30 days',
    'Chance to make a promise this week',
    'Chance to make a promise today',
    'Chance to pay in 30 days',
    'Chance to pay this week',
    'Chance to pay today',
    'Likely promise',
    'Next due'
  ],
  reconciliation: [
    'Amount',
    'Customer ID',
    'Date/Time',
    'Date/Time (UTC)',
    'Error',
    'External ID',
    'First name',
    'Last name',
    'Last retry',
    'Last retry (UTC)',
    'Merchant',
    'Origin',
    'Other',
    'Resolvable',
    'Resolved by',
    'Retries',
    'Status',
    'Unresolved'
  ],
  'repeat-card-usage': [
    'Approvals',
    'Approved amount',
    'Approved amount (USD)',
    'Attempts',
    'Block candidates',
    'Candidates',
    'Card BIN',
    'Cards',
    'Decline rate',
    'Declines',
    'Peak'
  ],
  'retry-analysis': [
    'Avg. seconds to retry',
    'BIN',
    'Card brand',
    'Decline code',
    'Discover',
    'Failed again on retry',
    'First-attempt failures',
    'Mastercard',
    'Not retried',
    'Reason',
    'Replaces NMI code',
    'Retry success rate',
    'Retry success rate (0-1)',
    'Succeeded on retry',
    'Visa'
  ],
  'retry-analysis-tsys': [
    'Avg. seconds to retry',
    'BIN',
    'Card brand',
    'Decline code',
    'Discover',
    'Failed again on retry',
    'First-attempt failures',
    'Mastercard',
    'Not retried',
    'Reason',
    'Replaces NMI code',
    'Retry success rate',
    'Retry success rate (0-1)',
    'Succeeded on retry',
    'Visa'
  ],
  rewind: [
    'ACH transactions',
    'Active',
    'BlytzCash transactions',
    'Busiest month',
    'Card transactions',
    'Customers (cash payments)',
    'First transaction',
    'Kiosk cash transactions',
    'Last transaction',
    'Merchant',
    'Merchant id',
    'Merchants',
    'Month',
    'Other months',
    'Top 3 months',
    'Transactions',
    'Volume',
    'Volume (USD)'
  ],
  'sales-activity': [
    'Calls',
    'Conversations',
    'Emails',
    'Led to a deal',
    'Meetings',
    'Meetings held',
    'Meetings to opportunity',
    'Meetings upcoming',
    'Outreach',
    'Texts',
    'Week of'
  ],
  'sales-book-onboarding': [
    'Add-ons',
    'Average days in stage',
    'Deals',
    'Live',
    'Onboarding stage',
    'Other',
    'Pending go-live',
    'Sold in the period',
    'Stage type',
    'Stuck',
    'Went live'
  ],
  'sales-pipeline': [
    'Closing next month',
    'Closing this month',
    'Not yet due',
    'Open deals',
    'Past expected close',
    'Stage'
  ],
  'sales-scorecard': [
    'Group',
    'Measure',
    'Meetings to opportunity',
    'Open deals',
    'Outreach',
    'Unit',
    'Value',
    'Win rate'
  ],
  'sales-tools-pricing-studio': [
    'Est. merchant monthly bill',
    'Net margin',
    'Net revenue',
    'Total gross revenue'
  ],
  'sales-win-loss': [
    'Average days to close',
    'Citations',
    'Closed',
    'Conversion',
    'Deals',
    'Deals lost',
    'Deals won',
    'Lost',
    'Quarter',
    'Reached next stage',
    'Reached stage',
    'Win rate',
    'Won'
  ],
  'same-day-repeats': [
    'Approved',
    'Approved amount',
    'Approved amount (USD)',
    'Attempts',
    'Card-days',
    'Day',
    'Declined',
    'Merchant',
    'Most uses',
    'Most uses of one card in a day',
    'Repeating card-days'
  ],
  'service-performance': [
    '4xx rate',
    '5xx rate',
    'Cloud Run 5xx rate',
    'Cloud Run p95',
    'Cloud Run requests',
    'Deployment',
    'Max',
    'Mean',
    'Other',
    'Requests',
    'Service',
    'p50',
    'p95',
    'p99'
  ],
  'tpv-tcv-peaks': [
    'Active merchants',
    'Average day',
    'Day',
    'Highest day',
    'Month',
    'Peak day',
    'Peak days',
    'TCV',
    'TCV rank',
    'TCV rank in month',
    'TPV',
    'TPV (USD)',
    'TPV rank',
    'TPV rank in month',
    'Week of month',
    'Weekday'
  ],
  'transaction-scoring': [
    '5x merchant average',
    'ACH High / Medium',
    'Alerts',
    'Amount',
    'Amount (USD)',
    'At least 5x merchant average',
    'Average score',
    'Card Very High / Medium',
    'Flagged',
    'Merchant',
    'Merchant ID',
    'Merchant average',
    'Merchant average (365 days)',
    'Merchant average, 365 days (USD)',
    'Merchant tenure (days)',
    'Off hours',
    'Off-hours',
    'Scored transactions',
    'Tenure (days)',
    'Tier',
    'Top score',
    'Type'
  ],
  'twilio-replies': [
    'Bounce rate',
    'Bounced',
    'Customers',
    'Delivered',
    'Merchant',
    'Merchant ID',
    'Not recorded',
    'Opt-in',
    'Opt-in texts',
    'Opt-out',
    'Opt-out request',
    'Opt-out requests',
    'Opt-out texts',
    'Opted in again',
    'Recorded',
    'Reply',
    'Texts'
  ],
  'unanswered-questions': ['Askers', 'Group', 'Questions', 'Sample questions'],
  undelivered: [
    'Account #',
    'Customer #',
    'Merchant',
    'Name',
    'Other',
    'Reason',
    'Status',
    'Text date',
    'Texted number',
    'Total messages'
  ],
  'weekly-trends': [
    'Active dealers',
    'Average TPV per dealer',
    'Average TPV per dealer (USD)',
    'Average ticket',
    'Average ticket (USD)',
    'Complete week',
    'Latest complete week TCV',
    'Latest complete week TPV',
    'TCV',
    'TPV',
    'TPV (USD)',
    'Week end',
    'Week start'
  ]
}
